import { render, staticRenderFns } from "./App.vue?vue&type=template&id=583e64d8&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=583e64d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_css-loader@0.28.11_lodash@4.17.21_vue-template-compiler@2.7.16_webpack@5.99.6_webpack-cli@4.10.0_/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583e64d8",
  null
  
)

export default component.exports